exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-maintain {\n  text-align: center;\n  padding: 10%;\n  font: 20px Helvetica, sans-serif;\n  color: #333; }\n\nh1 {\n  font-size: 50px;\n  margin: 0; }\n\narticle {\n  display: block;\n  text-align: left;\n  max-width: 650px;\n  margin: 0 auto; }\n\na {\n  color: #21409a;\n  text-decoration: none; }\n\na:hover {\n  color: #333;\n  text-decoration: none; }\n\n@media only screen and (max-width: 480px) {\n  h1 {\n    font-size: 40px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/site-maintenance/site-maintenance.component.scss
// module id = ../../../../../src/app/site-maintenance/site-maintenance.component.scss
// module chunks = main